import { useState } from 'react';

import useResize from 'js/hooks/use-resize';

const screens = {
  smMax: 'screen and (max-width: 510px)',
  mdMax: 'screen and (max-width: 768px)',
  md: 'print, screen and (min-width: 768px)',
  lg: 'print, screen and (min-width: 1024px)'
} as const;

type ScreenSize = keyof typeof screens;

const useIsScreenSize = (screenSize: ScreenSize = 'lg'): boolean | undefined => {
  const [isScreenSize, setIsScreenSize] = useState<boolean | undefined>(undefined);

  const screen = screens[screenSize];

  const onResize = () => {
    setIsScreenSize(window.matchMedia(screen).matches);
  };

  useResize(onResize);

  return isScreenSize;
};

export default useIsScreenSize;
